// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_eg-0";
export var fileCarousel = "_eg-2";
export var removeFileButton = "_eg-1";